import { LSBX } from '@/config/bank-lsbx';
import { AppConfig } from './types';
import { defaultConfig } from '@/config/default';

const royalpayConfig = {
  brandName: 'RoyalPay',
  documents: {
    'bank_privacy_policy.pdf': {
      document: 'bank_privacy_policy.pdf',
      label: 'Lincoln Savings Bank’s privacy policy',
      version: '1.0',
    },
    'brand_privacy_policy.pdf': {
      document: 'brand_privacy_policy.pdf',
      label: 'Royal’s Privacy Policy',
      version: '1.0',
    },
    'brand_terms_of_use.pdf': {
      document: 'brand_terms_of_use.pdf',
      label: 'Royal’s Terms of Use',
      version: '1.0',
    },
    'deposit_account_agreement.pdf': {
      document: 'deposit_account_agreement.pdf',
      label: 'RoyalPay’s deposit account agreement',
      version: '1.0',
    },
    'secured_charge_card_agreement.pdf': {
      document: 'secured_charge_card_agreement.pdf',
      label: 'RoyalPay’s secured charge card agreement',
      version: '1.0',
    },
  },
  sponsorBank: LSBX,
  support: {
    email: 'support@royalsecure.com',
    phone: '1-888-906-9581',
  },
};

export const defaultRoyalpayConfig: AppConfig = {
  ...defaultConfig,
  ...royalpayConfig,
};

// BOOST Payfac
export const boostConfig: AppConfig = {
  brandName: 'BOOST Payfac',
  programDisplayName: 'commercial secured card',
  sponsorBank: royalpayConfig.sponsorBank,
  support: royalpayConfig.support,
  theme: {
    'action-button-disabled-color': '#ACACAC',
    'action-button-hover-color': '#DAF3E6',
    'action-button-hover-text-color': '#000000',
    'action-button-text-color': '#000000',
    'action-color': '#48C585', // maps to old interaction color
    'primary-brand-color': '#48C585', // maps to old action color
  },
};

// Inksoft
export const inksoftConfig: AppConfig = {
  brandName: 'Inksoft',
  programDisplayName: 'commercial secured card',
  sponsorBank: royalpayConfig.sponsorBank,
  support: royalpayConfig.support,
  theme: {
    'action-button-disabled-color': '#ACACAC',
    'action-button-hover-color': '#DAF3E6',
    'action-button-text-color': '#000000',
    'action-color': '#DAF3E6', // maps to old interaction color
    'primary-brand-color': '#48C585', // maps to old action color
  },
};

// Payrix
export const payrixConfig: AppConfig = {
  brandName: 'Payrix',
  programDisplayName: 'commercial secured card',
  sponsorBank: royalpayConfig.sponsorBank,
  support: royalpayConfig.support,
  theme: {
    'action-button-disabled-color': '#ACACAC',
    'action-button-hover-color': '#DCECD7',
    'action-button-hover-text-color': '#000000',
    'action-button-text-color': '#000000',
    'action-color': '#51A63B', // maps to old interaction color
    'primary-brand-color': '#51A63B', // maps to old action color
  },
};

// Printavo
export const printavoConfig: AppConfig = {
  brandName: 'Printavo',
  programDisplayName: 'commercial secured card',
  sponsorBank: royalpayConfig.sponsorBank,
  support: royalpayConfig.support,
  theme: {
    'action-button-disabled-color': '#ACACAC',
    'action-button-hover-color': '#DCECD7',
    'action-button-text-color': '#000000',
    'action-color': '#DCECD7', // maps to old interaction color
    'primary-brand-color': '#51A63B', // maps to old action color
  },
};
